import React, { useContext, useEffect } from "react";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
  useNavigate,
} from "react-router-dom";
import RouteContext from "./utils/context/RouteContext";
import { roles } from "./components/sidenav/constant";
import { allRoutes } from "./App";

const AppRoutes = () => {
  const { allowedRoutes, setAllowedRoutes, role, accessibleModules } =
    useContext(RouteContext);

  useEffect(() => {
    const userInfo = localStorage.getItem("user");
    if (userInfo) {
      const user = JSON.parse(userInfo);
      const levelPermission = user?.subAdmin?.level?.levelPermission;
      if (role === roles.SUB_ADMIN) {
        let allowedNestedModule = [
          allowedRoutes?.[2].children[0],
          allowedRoutes?.[2].children[1],
        ];
        const levels = levelPermission.filter((item) =>
          accessibleModules.includes(item.module.name)
        );

        allowedRoutes?.[2].children.forEach((item) => {
          console.log(accessibleModules, "accessibleModules");

          const level = levels.filter((ccc) => ccc.module.name === item.module);

          if (level.length > 0) {
            let { edit, ...rest } = item;

            console.log(level, "levellevel");
            if (level[0].read || level[0].write) {
              if (level[0].write && item.children && edit) {
                rest["children"] = [...rest.children, ...edit];
              }
              console.log(rest, "edittttt");
              allowedNestedModule.push(rest);
            }
          }
        });

        console.log(allowedNestedModule, "allowedNestedModule");

        const modifiedAllowedRoutes = [
          ...allowedRoutes.slice(0, 2),
          {
            ...allowedRoutes[2],
            children: allowedNestedModule,
          },
        ];

        setAllowedRoutes(modifiedAllowedRoutes);
      } else {
        // let module = [allowedRoutes?.[2].children[0]];
        const nestedChildrenRoutes = allRoutes?.[2].children.map((item) => {
          let { edit, ...rest } = item;
          if (edit) {
            rest["children"] = [...rest?.children, ...edit];
          }

          return rest;
        });

        const modifiedAllowedRoutes = [
          ...allowedRoutes.slice(0, 2),
          {
            ...allowedRoutes[2],
            children: nestedChildrenRoutes,
          },
        ];
        setAllowedRoutes(modifiedAllowedRoutes);
      }
    }
  }, [role]);

  console.log(allowedRoutes, "nestedChildrenRoutesssssss");
  const routes = createBrowserRouter(allowedRoutes);

  return <RouterProvider router={routes} />;
};

export default AppRoutes;
